import axios from 'axios';

export async function getIpData(ip) {
  return await axios.get(`https://api.ipdata.co/${ip ?? ''}`, {
    params: {
      'api-key': process.env.REACT_APP_IPDATA_API_KEY,
    },
  });
}
